/**
 * External dependencies
 */
import React from 'react';
import Preloader from 'components/preloader';
import { get } from 'lodash';

export const renderRecharts = (Component) => ({ resultSet, error }) => {
	const first = get(resultSet, ['main'], null);
	const compare = get(resultSet, ['compare'], null);
	return (
		(resultSet && <Component compareResultSet={compare} resultSet={first} />) ||
		(error && error.toString()) || <Preloader />
	);
};
